import geoService from "../../services/geoService";
import leadService from "../../services/leadService";

const getDefaultState = () => {
  return {
    valid: false,
    zipCode: null,
    cityList: [],
    providersElec: [],
    providersGas: [],
    city: null,
    area: null,
    simulation: false,
    providerElec: null,
    providerGas: null
  };
};

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    setValid(state, value) {
      state.valid = value;
    },
    setZipCode(state, value) {
      state.zipCode = value;
    },
    setCityList(state, value) {
      state.cityList = value;
    },
    setCity(state, value) {
      state.city = value;
    },
    setArea(state, value) {
      state.area = value;
    },
    setSimulation(state, value) {
      state.simulation = value;
    },
    setProvidersElec(state, value) {
      state.providersElec = value;
    },
    setProvidersGas(state, value) {
      state.providersGas = value;
    },
    setProviderElec(state, value) {
      state.providerElec = value;
    },
    setProviderGas(state, value) {
      state.providerGas = value;
    },
    reset(state) {
      Object.assign(state, getDefaultState());
    }
  },
  actions: {
    async getCity(context) {
      try {
        let response = await geoService.getCity(context.state.zipCode);
        context.commit("setCityList", response.towns);
        context.commit("setArea", response.region);
        if (!context.state.cityList.includes(context.state.city))
          context.commit("setCity", response.towns[0]);
      } catch (error) {
        throw error;
      }
    },
    async getProviders(context) {
      try {
        let response = await geoService.getProviders(context.state.zipCode);
        context.commit("setCityList", response.towns);
        context.commit("setArea", response.region);
        if (!context.state.cityList.includes(context.state.city))
          context.commit("setCity", response.towns[0]);

        // Remove mega and others
        let elecProviders = response.energyProviders.electricity.filter(
          provider => provider.id !== "200084" && provider.id !== "200076"
        );
        let gasProviders = response.energyProviders.gas.filter(
          provider => provider.id !== "200084" && provider.id !== "200076"
        );

        context.commit("setProvidersElec", elecProviders);
        if (
          !elecProviders.find(
            provider => provider.id === context.state.providerElec
          )
        ) {
          let defaultProvider = elecProviders[0];
          defaultProvider =
            elecProviders.find(provider => provider.name === "Engie") ||
            defaultProvider;
          context.commit("setProviderElec", defaultProvider.id);
        }

        context.commit("setProvidersGas", gasProviders);
        if (
          !gasProviders.find(
            provider => provider.id === context.state.providerGas
          )
        ) {
          let defaultProvider = gasProviders[0];
          defaultProvider =
            gasProviders.find(provider => provider.name === "Engie") ||
            defaultProvider;
          context.commit("setProviderGas", defaultProvider.id);
        }
      } catch (error) {
        throw error;
      }
    },
    async save(context) {
      let data = {
        uuid: context.rootState.common.uuid,
        zipCode: context.state.zipCode,
        area: context.state.area,
        city: context.state.city,
        simulation: context.state.simulation,
        providerElec: context.state.providerElec,
        providerGas: context.state.providerGas
      };

      try {
        await leadService.save(data);
      } catch (error) {
        throw error;
      }
    }
  },
  getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/calculation.js